export enum BillingInvoicesColumns {
  company = "company_id",
  companies = "companies",
  created = "created",
  from = "date_from",
  to = "date_to",
  period = "billing_period",
  pdf = "pdf",
  xlsx = "xlsx",
  actions = "actions",
  total = "total",
}
